import React, { startTransition } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initAnalytics } from "./utils/analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Rendered as a transition so React yields to the browser every few milliseconds
// instead of building the whole home page in one long task. The static shell in
// index.html stays on screen until the finished tree replaces it, and the main
// thread stays free for input (long tasks count against Total Blocking Time).
startTransition(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Third-party analytics must never compete with first paint: it loads after the
// page has finished loading (see utils/analytics.js). Firebase itself is
// initialised lazily by whichever module first needs it, so nothing is started
// here. EmailJS needs no global init: ContactForm passes its public key per call.
initAnalytics();
